export default __webpack_public_path__ + "static/media/Think5WhysRadio.003366c815ea5c58bcb5e528dcceda34.webp";